module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/star-rating-efa6cffb4651c68f97f02febee3f223d.svg";